import { React, useContext, useEffect, useState } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { useLocation, useNavigate } from "react-router";
import { filterLocationUrl, tagList, filterSectorByIndutry } from "../../Config/config";
import axios from "axios";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import DefinitionModal from "../TagDefinitionModal";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";


function InvestorIncubator({ customPathname, generalPathname }) {
    const {
        setSectors, Sectors, lAdvisorsOptions, setlAdvisorsOptions, tAdvisorsOptions, settAdvisorsOptions, dbDropdown, setDbDropdown, checkToggleBtn, setToggleDealsBtn,
        onErrorHandler, SwitchState, setSwitchState, dropdown,
        InvestorOptions, setInvestorOptions, TargetCompanyOptions, setTargetCompanyOptions, AllCities,
        setrefineSearchFilters,
        refineSearchFilters, setMonthPickerValue
    } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const navigate = useNavigate();
    const { getToken } = useContext(UserContext);
    const location = useLocation();
    const { pathname } = useLocation();
    const isFromGlobalSearch = () => refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false;
    const isFromSearchedList = () => refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false;

    const [IndustriesOptions, setIndustriesOptions] = useState([]);
    const [SectorOptions, setSectorOptions] = useState([]);
    const [EndYearOptions, setEndYearOptions] = useState([]);
    const [StartYearOptions, setStartYearOptions] = useState([]);
    const [CountryOptions, setCountryOptions] = useState([]);
    const [RegionOptions, setRegionOptions] = useState([]);
    const [StateOptions, setStateOptions] = useState([]);
    const [CityOptions, setCityOptions] = useState([]);
    const [TagSwitchState, setTagSwitchState] = useState(true);
    const [TagsOptions, setTagsOptions] = useState([]);
    const [FirmTypeOptions, setFirmTypeOptions] = useState([]);
    const [VCFundedOptions, setVCFundedOptions] = useState([]);
    const [IncubationStatusOptions, setIncubationStatusOptions] = useState([]);
    const [isExclude, setisExclude] = useState(false);

    useEffect(() => {
        const ids = IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id);

        if (ids?.length > 0) {
            axios.post(filterSectorByIndutry, {
                "industry": ids,
                category: "investments"
            }, {
                headers: {
                    "Authorization": getToken()
                }
            }).then(response => {
                if (response.status === 200) {
                    setSectors(response.data?.data ?? []);
                } else {
                    setSectors([]);
                }
            }).catch(onErrorHandler);
        } else {
            setSectors([]);
        }
    }, [IndustriesOptions]);

    const applyFilter = () => {
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked);
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {
                ...prev[customPathname],
                investor_id: selectedInvestor,
                target_company: selectedTargetCompany,
            },
        }));
        checkToggleBtn();
    };

    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {},
            [customPathname]: {}
        }));
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setSectors([]);
        setToggleDealsBtn(true);
    };

    useEffect(() => {
        setToggleDealsBtn(true);
    }, [customPathname]);

    const refineSearchFilter = (event) => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
            },
            [customPathname]: { globalSearch: [] }
        }));
        if (isFromGlobalSearch() || isFromSearchedList()) {
            setMonthPickerValue(Constants.initialMonthRange);
        }
        event.preventDefault();
        setCurrentPage(1);
        applyFilter();
        if (location.pathname !== customPathname) {
            navigate(customPathname);
        }
        setSelected(false);
    };

    useEffect(() => {
        setrefineSearchFilters((prev) => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
                firmType: [],
                firm_Sub_type: [],
            }
        }));
    }, []);

    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        resetFilter();
        if (location.pathname !== customPathname) {
            navigate(customPathname);
        }
    };

    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    const onCountryChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: ids,
            region: [],
            state: [],
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setRegionOptions(response.data?.region);
                setStateOptions(response.data.state);
                setCityOptions(response.data?.city);
            }
        }).catch(onErrorHandler);
    };

    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setStateOptions(response.data.state);
                setCityOptions(response.data?.city);
            }
        }).catch(onErrorHandler);
    };

    const onStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: selectedRegion,
            state: ids,
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCityOptions(response.data?.city);
            }
        }).catch(onErrorHandler);
    };

    useEffect(() => {
        const countryIds = refineSearchFilters[customPathname]?.countries?.map(value => value.id) ?? [];
        const ids = refineSearchFilters[customPathname]?.region?.map(value => value.id) ?? [];
        const stateIds = refineSearchFilters[customPathname]?.state?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[customPathname]?.city?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: countryIds.includes(option.id) })));
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })));
                setStateOptions(response.data.state?.map(option => ({ ...option, isChecked: stateIds.includes(option.id) })));
                setCityOptions(AllCities?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })));
            }
        }).catch(onErrorHandler);
    }, [refineSearchFilters]);

    const getSearchTags = async (searchText, type) => {
        try {
            const response = await axios.post(tagList, {
                "tag": searchText,
                "type": type
            }, {
                headers: {
                    "Authorization": getToken()
                }
            });

            if (response.status === 200) {
                return response.data;
            } else {
                return [];
            }
        } catch (error) {
            return [];
        }
    };

    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor");
        openTagModal(tags, competitorTags);
    };

    const [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({});
    const openTagModal = (non_comp, comp) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp
        });
    };

    const defCloseHandler = () => {
        setShowDefinitionModal(false);
        setDefValues({});
    };

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    return (
        <div className="h-screen">
            <div className={isFromGlobalSearch() ? "flex flex-col overflow-y-auto no-scrollbar h-[72%]" : "flex flex-col overflow-y-auto no-scrollbar lg:h-[62%] xl:h-[68%] 2xl:h-[75%] fixedFooter"}>
                <form onSubmit={refineSearchFilter} onReset={onResetClick}>
                    <main className="bg-[#FAF5EA] w-full">
                        <ul className={`transition-max-h overflow-y-auto duration-500 ease-in-out ${dropdown ? 'max-h-[1000px]' : 'max-h-0 overflow-y-hidden'} text-[#333333] font-sans_book_body text-[14px] leading-[17px] tracking-[-0.3px]`}>
                            <Investor
                                options={InvestorOptions}
                                setOptions={setInvestorOptions}
                                customPathname={customPathname}
                                accordionClick={() => accordionClick(32)}
                                label="Incubator"
                                open={select === 32}
                            />
                            <TargetCompany
                                options={TargetCompanyOptions}
                                setOptions={setTargetCompanyOptions}
                                customPathname={customPathname}
                                accordionClick={() => accordionClick(31)}
                                label="Company"
                                open={select === 31}
                            />
                        </ul>
                        <div className="px-3 py-2 flex space-x-4 bg-[#FAF5EA] fixed w-60 bottom-0">
                            <button type="reset" className="w-[64px] h-[28px] border-2 border-[#B8B8B8] rounded-[3px] text-[#666666] text-[13px] font-sans_book_body leading-[17px] tracking-[-0.3px]">
                                Reset
                            </button>
                            <button onClick={(select)} type="submit" className="bg-[#BC8B20] w-[145px] h-[28px] text-[#FFFFFF] text-[13px] rounded-[3px] font-sans_medium_body leading-[17px]">
                                Filter
                            </button>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal values={defValues} onClose={defCloseHandler} />}
        </div>
    );
}

export default InvestorIncubator;